# Ad selection

Going forward, the SEEK ad products available for selection will vary between hirers, markets, and over time.
For example, an Australian hirer may choose between `Classic`, `StandOut` and `Premium` or just `StandOut` and `Premium`,
while a Singaporean hirer may have access to `Basic`, `Branded` and `Premium`.

We have built two options to accommodate this new variable model for ad selection.
Your software must adopt one of these dynamic options and must not hardcode any logic based on specific names or identifiers as SEEK ad products may continue to evolve.

import { Alert, Text } from 'braid-design-system';

<Alert tone="promote">
  <Text>
    SEEK strongly recommends using the Ad Selection Panel for your integration.
    It will significantly reduce development time and ongoing maintenance, as
    well as provide an up-to-date user experience for SEEK hirers.
  </Text>
</Alert>

## Option 1: Ad Selection Panel

SEEK has created an updated Ad Selection Panel that you can embed into your posting flow.

Refer to the [panel uplift section](/migration-guides/jobstreet-and-jobsdb-uplift/phase-2-job-posting/ad-selection/panel) to view more details.

## Option 2: GraphQL

If you’re unable to use the Ad Selection Panel,
your custom user interface must be rebuilt on our new `advertisementProducts` query.

Refer to the [GraphQL uplift section](/migration-guides/jobstreet-and-jobsdb-uplift/phase-2-job-posting/ad-selection/graphql) to view more details.
